import { render } from "./user-identification-app.vue?vue&type=template&id=7ec0caaa&scoped=true&lang=pug"
import script from "./user-identification-app.vue?vue&type=script&lang=js"
export * from "./user-identification-app.vue?vue&type=script&lang=js"

import "./user-identification-app.vue?vue&type=style&index=0&id=7ec0caaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec0caaa"]])

export default __exports__